import i18n from "../../../../constants/i18n";
import { ADMIN_AUDIT_LIST_HEADERS } from "../../../../constants/table-custom-headers/Auditor";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getAuditStore from "../../../../stores/auditor-store/audit-store";
import ReportsBox from "./ReportsBox";
import Et3Table from "../../../../core/et3-table";

const EventsData = withLiteObserverAndTheme(() => {
  const eventsList = getAuditStore().eventsListOrdered.get();
  const typeInput = getAuditStore().typeInputAudit.get().value;

  return typeInput === "report" ? (
    <ReportsBox />
  ) : (
    <Et3Table
      columns={ADMIN_AUDIT_LIST_HEADERS}
      rows={eventsList}
      title={i18n.get("EVENTS_LIST")}
      shouldBeFlagged={false}
      titleKey={"EVENTS_LIST"}
    />
  );
});

export default EventsData;
